import { Injectable } from '@angular/core';
//import { HttpClientAuth } from './http.client';
import { Client } from './models/client';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ClientService } from './clients/client.service';
import { map } from 'rxjs/operators';

interface ListClientsResponse {
  data: any;
}

@Injectable()
export class ClientRepository {
  clients: Client[];

  constructor(private http: HttpClient,
              private clientService: ClientService) {

    this.clientService.changed.subscribe(() => {
      this.init();
    });
  }

  init() {
    return this.get().pipe(
      map(clients => {
        this.clients = clients;
      }))
      .toPromise();
  }

  get(): Observable<Client[]> {
    return this.http.get<ListClientsResponse>(`${environment.apiUrl}/clients`)
      .pipe(
        map(responseJson => {
          return responseJson.data.map(row => {
            return Client.fromJson(row);
          })
        }));
  }
}



// WEBPACK FOOTER //
// ./src/app/client.service.ts